import { render } from "./MenuTableItems.vue?vue&type=template&id=40cfdb37&scoped=true"
import script from "./MenuTableItems.vue?vue&type=script&lang=js"
export * from "./MenuTableItems.vue?vue&type=script&lang=js"

import "./MenuTableItems.vue?vue&type=style&index=0&id=40cfdb37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cfdb37"]])

export default __exports__